import { http } from '@/shared/api/http';

import type { Group } from '../model/useGroups';

export const fetchGroups = async (
  search: string
): Promise<{ result: Group[] }> => {
  const params = search ? { search } : {};

  const { data } = await http.get<{ result: Group[] }>('/groups/list', {
    params,
  });

  return data;
};
